import * as React from 'react';
const SvgEmailMarketing = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.548 65.87V15.546h92.899V65.87M2 73.612l54.941 26.584a11.628 11.628 0 0 0 10.118 0L122 73.612"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m15.548 28.611-13.47 8.226H2v77.421A7.74 7.74 0 0 0 9.742 122h104.512a7.74 7.74 0 0 0 7.741-7.742V36.837h-.077l-13.471-8.226M36.586 15.545l19.35-11.84a11.62 11.62 0 0 1 12.12 0l19.349 11.84"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.739 42.644V60.45c.13 7.317 17.433 11.759 17.496-8.139 0-.314 0-.629-.01-.938-.232-10.302-8.157-19.423-18.821-21.697-10.989-2.347-22.887 2.55-28.228 12.561-5.778 10.83-3.987 25.776 6.266 33.267 5.8 4.239 13.209 5.927 20.423 5.845"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.74 44.647c-3.46-1.118-8.1-1.33-11.449.087-6.212 2.627-8.67 9.687-6.977 15.199.861 2.806 3.208 5.366 6.42 6.27 6.431 1.815 10.094-1.422 11.932-5.462"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgEmailMarketing;
